"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles = {
    outerContainer: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(255,255,255,0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1,
    },
    innerContainer: {
        boxSizing: 'initial',
        backgroundColor: '#fff',
        boxShadow: '0 0 0 0, 0 8px 16px rgba(0,0,0,.30)',
        display: 'flex',
        flexDirection: 'column',
        minWidth: '300px',
        minHeight: '140px',
        justifyContent: 'space-between',
        borderRadius: '5px',
    },
};
const Modal = ({ children, open = false, onClose = () => null, style, }) => {
    const handleClose = (0, react_1.useCallback)((e) => {
        onClose(e);
    }, [onClose]);
    (0, react_1.useEffect)(() => {
        if (!open) {
            handleClose();
        }
    }, [handleClose, open]);
    return (open && ((0, jsx_runtime_1.jsx)("div", { style: styles.outerContainer, onClick: handleClose, children: (0, jsx_runtime_1.jsx)("div", { style: { ...styles.innerContainer, ...style }, onClick: (e) => {
                e.preventDefault();
                e.stopPropagation();
            }, children: children }) })));
};
exports.default = Modal;
